import api from '../utils/api';

export const getPaymentGatewayTypes = async () => {
  const response = await api.get('/payment-gateways/meta/types');
  return response.data;
};

export const getPaymentGateways = async () => {
  const response = await api.get('/payment-gateways');
  return response.data;
};

export const getPaymentGateway = async (id) => {
  const response = await api.get(`/payment-gateways/${id}`);
  return response.data;
};

export const createPaymentGateway = async (data) => {
  const response = await api.post('/payment-gateways', data);
  return response.data;
};

export const updatePaymentGateway = async (id, data) => {
  const response = await api.put(`/payment-gateways/${id}`, data);
  return response.data;
};

export const deletePaymentGateway = async (id) => {
  const response = await api.delete(`/payment-gateways/${id}`);
  return response.data;
};
